import React, { Component } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { displaySubsidyEmployees } from "../../displays/allowance/display-subsidy-employees";
import { searchEmployeeSubsidyTable } from "../../search-employee-subsidy-table";
import AllowanceEmployeeRow from "./AllowanceEmployeeRow";
import { calculateAmount } from "../../calculateAmount";
import {
  translate as t,
  getLanguage,
} from "../../../../infrastructure/translate/localization";
import { customEmployeeAllowance } from "../../../../infrastructure/allowance-config-repository";
import { MonetaryAmount } from "../../../../app/domain/monetary-amount";

import "./subsidy-employees-table.scss";

const langTag = getLanguage();

export default class SubsidyEmployeesTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
    };
  }

  componentDidMount() {
    const { employeeIds } = this.props;
    if (employeeIds.length > 0) {
      this.handlerCalculateAmount();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.handlerCalculateAmount();
    }
  }

  handlerCalculateAmount = () => {
    calculateAmount({ ...this.props });
  };

  handlerChange = ({ id, name, value }) => {
    customEmployeeAllowance({ id, name, value });
    this.handlerCalculateAmount();
    displaySubsidyEmployees({ ...this.props });
  };

  handlerSubsidyEmployeePage = (page) => {
    displaySubsidyEmployees({
      ...this.props,
      currentPage: page,
    });
  };

  getAmountEmployee = (employee) => {
    const { mealBenefit, transportBenefit, nurseryBenefit } = this.props;
    const defaultAmount = MonetaryAmount.ZERO;
    const meals = mealBenefit
      ? MonetaryAmount.fromUnitary(employee.mealDays * employee.mealAmount)
      : defaultAmount;
    const trans = transportBenefit
      ? MonetaryAmount.fromUnitary(employee.transportAmount)
      : defaultAmount;
    const nurse = nurseryBenefit
      ? MonetaryAmount.fromUnitary(employee.nurseryAmount)
      : defaultAmount;

    return { meals, trans, nurse };
  };

  render() {
    const {
      employeeIds,
      employees,
      employeesItems,
      currentPage,
      pageCount,
      model,
      recurrentSubsidy,
      mealBenefit,
      transportBenefit,
      nurseryBenefit,
      countryISO2Code,
    } = this.props;

    const { search } = this.state;

    return (
      <div className="subsidy-employee-table">
        <div className="cob-btn-group right-group">
          <div className="cob-search">
            <FontAwesomeIcon icon="search" />
            <input
              type="string"
              placeholder={t("actions.search")}
              value={search}
              onChange={(e) => {
                this.setState({ search: e.target.value });
                searchEmployeeSubsidyTable({
                  employeeIds,
                  employeesItems,
                  value: e.target.value,
                  model,
                  mealBenefit,
                  transportBenefit,
                  nurseryBenefit,
                  recurrentSubsidy,
                });
              }}
            />
          </div>
        </div>

        <table>
          <thead>
            <tr>
              <th>{t("common-messages.internal-id")}</th>
              <th>{t("common-messages.employee")}</th>
              <th colSpan="2" hidden={!mealBenefit}>
                {t("benefits-section.meal-benefit.meal")}
              </th>
              <th hidden={!transportBenefit}>
                {t("benefits-section.transport-benefit.transport")}
              </th>
              <th hidden={!nurseryBenefit}>
                {t("benefits-section.nursery-benefit.nursery")}
              </th>
              <th>{t("subsidy-section.recharge-amount")}</th>
            </tr>
          </thead>
          <tbody>
            {employees.map((emp) => {
              if (!employeesItems[emp.id]) {
                window.location.reload();
              }
              const { meals, trans, nurse } = this.getAmountEmployee(
                employeesItems[emp.id]
              );
              return (
                <AllowanceEmployeeRow
                  key={emp.id}
                  employee={emp}
                  employeesItem={employeesItems[emp.id]}
                  showMealBenefit={mealBenefit}
                  showTransportBenefit={transportBenefit}
                  showNurseryBenefit={nurseryBenefit}
                  handlerEditAllowance={({ name, value }) =>
                    this.handlerChange({ id: emp.id, name, value })
                  }
                  totalAllowanceAmount={meals
                    .add(trans)
                    .add(nurse)
                    .prettifyMoney({ langTag })}
                  countryISO2Code={countryISO2Code}
                />
              );
            })}
          </tbody>
        </table>
        <div className="pagination left" hidden={pageCount <= 1}>
          <p className="pagination-text">
            {t("common-messages.pag")}{" "}
            <span className="current-page">{currentPage + 1}</span>{" "}
            {t("common-messages.of")} <span>{pageCount}</span>
          </p>
          <div className="page-buttons">
            <button
              type="button"
              disabled={currentPage === 0}
              className="page-item"
              onClick={() => this.handlerSubsidyEmployeePage(currentPage - 1)}
            >
              <FontAwesomeIcon icon="angle-left" />
            </button>
            <button
              type="button"
              disabled={currentPage === pageCount - 1}
              className="page-item"
              onClick={() => this.handlerSubsidyEmployeePage(currentPage + 1)}
            >
              <FontAwesomeIcon icon="angle-right" />
            </button>
          </div>
        </div>
      </div>
    );
  }
}

SubsidyEmployeesTable.defaultProps = {
  recurrentSubsidy: false,
  mealBenefit: false,
  transportBenefit: false,
  nurseryBenefit: false,
  countryISO2Code: "ES",
};

SubsidyEmployeesTable.propTypes = {
  employeeIds: PropTypes.array.isRequired,
  employees: PropTypes.array.isRequired,
  employeesItems: PropTypes.object.isRequired,
  currentPage: PropTypes.number.isRequired,
  pageCount: PropTypes.number.isRequired,
  model: PropTypes.object.isRequired,
  recurrentSubsidy: PropTypes.bool,
  mealBenefit: PropTypes.bool,
  transportBenefit: PropTypes.bool,
  nurseryBenefit: PropTypes.bool,
  countryISO2Code: PropTypes.string,
};
